import React from "react";
import LegalPage from "@/components/LegalPage";

export default function RefundPolicy() {
  return (
    <LegalPage title="Refund Policy" testid="refund-page">
      <p>
        Each artwork on this site is a one-of-one original. We take great care to describe every
        piece accurately and to package it safely. This policy explains your rights if something
        is not right.
      </p>

      <h2>Change of Mind</h2>
      <p>
        Because every work is unique and hand-painted, we do not offer refunds for change of
        mind. Please review the size, story, photograph and price carefully before purchasing,
        and reach out at{" "}
        <a href="mailto:colleen.prosser@outlook.com">colleen.prosser@outlook.com</a>{" "}
        if you would like additional photos.
      </p>

      <h2>Damage in Transit</h2>
      <p>
        In the unlikely event that your artwork arrives damaged, please:
      </p>
      <ul>
        <li>Keep all packaging.</li>
        <li>Photograph the damage to the painting and to the outer packaging.</li>
        <li>Email us within 7 days of delivery at colleen.prosser@outlook.com.</li>
      </ul>
      <p>
        We will assess the claim and, where damage in transit is confirmed, arrange a full
        refund (including return shipping if required) or, where possible, a restoration by the
        Artist.
      </p>

      <h2>Not as Described</h2>
      <p>
        If the artwork received differs materially from what was shown on the website, you may
        return it within 14 days of delivery for a full refund. Please contact us before
        returning &mdash; we will provide a return address and shipping instructions.
      </p>

      <h2>Australian Consumer Law</h2>
      <p>
        Nothing in this policy limits your rights under the Australian Consumer Law. Our goods
        come with guarantees that cannot be excluded under those laws.
      </p>

      <h2>How Refunds Are Issued</h2>
      <p>
        Approved refunds are processed through Stripe to the original payment method within 5
        business days. Depending on your bank, the funds may take a further few business days
        to appear.
      </p>

      <h2>Cancellations</h2>
      <p>
        Orders cannot be cancelled once payment is confirmed and the artwork has been dispatched
        for delivery. If you need to cancel before dispatch, contact us as soon as possible and
        we will do our best to help.
      </p>

      <p className="text-xs uppercase tracking-widest text-[#5B5653] pt-8 border-t border-[#E3DDD7]">
        Last updated: {new Date().toLocaleDateString("en-AU", { month: "long", year: "numeric" })}
      </p>
    </LegalPage>
  );
}
